import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (password !== repeat) return setError("Adgangskoderne er ikke ens.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/password-reset/confirm", { token, password });
      localStorage.removeItem("en_token");
      setDone(true);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "Linket er ugyldigt eller udløbet.");
    } finally {
      setBusy(false);
    }
  };

  return <div className="mx-auto max-w-xl px-4 py-12 sm:py-20">
    <section className="rounded-[28px] border border-brand-line bg-white p-6 shadow-[0_24px_70px_rgba(45,42,38,.08)] sm:p-10">
      <p className="text-xs font-bold uppercase tracking-[.16em] text-brand-fresh">Kontosikkerhed</p>
      <h1 className="mt-3 text-3xl font-bold text-brand-ink">Vælg en ny adgangskode</h1>
      {done ? <><div className="mt-6 rounded-2xl bg-brand-soft p-5 text-sm text-brand-green">Adgangskoden er ændret. Alle tidligere sessioner er gjort ugyldige.</div><Link to="/log-ind" className="btn-primary mt-6 inline-flex">Log ind</Link></> :
      !token ? <div className="mt-6 rounded-xl bg-[#FFF1EE] p-4 text-sm text-[#991B1B]">Der mangler et gyldigt link. Bed om et nyt fra login-siden.</div> :
      <form onSubmit={submit} className="mt-7 space-y-5">
        <PasswordField label="Ny adgangskode" value={password} onChange={setPassword}/>
        <PasswordField label="Gentag adgangskode" value={repeat} onChange={setRepeat}/>
        {error && <div className="rounded-xl bg-[#FFF1EE] px-4 py-3 text-sm text-[#991B1B]" role="alert">{error}</div>}
        <button disabled={busy} className="btn-primary min-h-12 w-full rounded-xl">{busy ? "Gemmer…" : "Gem ny adgangskode"}</button>
      </form>}
    </section>
  </div>;
}

function PasswordField({ label, value, onChange }) {
  return <label className="block text-sm font-semibold text-brand-ink">{label}
    <input type="password" minLength={8} maxLength={128} required autoComplete="new-password" value={value} onChange={(event) => onChange(event.target.value)} className="mt-2 min-h-12 w-full rounded-xl border border-brand-line px-4 font-normal outline-none focus:border-brand-fresh focus:ring-4 focus:ring-brand-fresh/10"/>
    <span className="mt-1 block text-xs font-normal text-brand-muted">Mindst 8 tegn</span>
  </label>;
}

